import { Box, Typography, useTheme } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import {
  ITabContentProps,
  PropertyFilterType,
  TitleDeedOptions,
} from '../configuration';
import ProductFilterActions from '../store/actions';
import SelectField from './SelectField';

const TabTitleDeed = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const dataTitleDeed = props.selections[PropertyFilterType.TitleDeed];
  const onValueChange = (key: string, value: string | number | null) => {
    if (value === 'null') value = null;
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.TitleDeed]: {
          ...dataTitleDeed,
          isChecked: value !== null,
          data: {
            ...dataTitleDeed.data,
            [key]: value === 1 ? true : value === 0 ? false : null,
          },
        },
      })
    );
  };
  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2
          translationKey={`title_deed`}
          defaultText="Title Deed"
        />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Select one'} />
      </Typography>
      <SelectField
        label={{ translationKey: '', defaultText: ' ' }}
        options={TitleDeedOptions}
        onValueChange={onValueChange}
        field={'title_deed'}
        value={
          dataTitleDeed.data.title_deed === true
            ? 1
            : dataTitleDeed.data.title_deed === false
            ? 0
            : null
        }
      />
    </Box>
  );
};

export default TabTitleDeed;
